import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import i18n from 'cityads-v3/i18n';

import CircularProgress from '@mui/material/CircularProgress';

import {
  getTools,
} from 'cityads-v3/actions/offers';

import {
  SUBSCRIPTION_STATUS_ID_PENDING,
  TOOL_ID_LANDING,
  TOOL_ID_BANNERS,
  TOOL_ID_BANNER_ROTATOR,
  TOOL_ID_COUPONS,
  TOOL_ID_GOODS_FEED,
  TOOL_ID_GOODS,
  TOOL_ID_FINANCE_API,
  TOOL_ID_WIDGETS,
} from 'cityads-v3/reducers/offers';

import ToolButton from './ToolButton';

import classes from './Tools.scss';

const TOOL_ORDER = [
  TOOL_ID_FINANCE_API,
  TOOL_ID_COUPONS,
  TOOL_ID_WIDGETS,
  TOOL_ID_GOODS,
  TOOL_ID_BANNERS,
  TOOL_ID_LANDING,
  TOOL_ID_GOODS_FEED,
  TOOL_ID_BANNER_ROTATOR,
];

export function Tools({
  offerId,
  offer,
  offerToolIds,
  offerSubscriptionStatus,
  t,
  dispatch,
  isLoggedIn,
  language,
  toolsById,
  isLoadingTools,
  isLoadedTools,
  subscriptions,
  isLoadedSubscriptions,
  accessRequested,
}) {
  useEffect(() => {
    dispatch(getTools());
  }, [dispatch, language]);

  if (!isLoadedTools || (isLoggedIn && !isLoadedSubscriptions)) {
    return (
      <div className={classNames(classes.container, classes.loading)}>
        <CircularProgress />
      </div>
    );
  }

  const isSubscribed = isLoggedIn && subscriptions.filter(item => item.isActiveSubscription).length > 0;
  const isRequested  = !!accessRequested[offerId];
  const offerToolSet = new Set(offerToolIds);
  const orderedTools = TOOL_ORDER.map(id => {
    return {
      ...toolsById[id],
      enabled: offerSubscriptionStatus !== SUBSCRIPTION_STATUS_ID_PENDING && offerToolSet.has(id),
    };
  });

  return (
    <div className={classes.container}>
      {orderedTools.map(tool => (
        <ToolButton
          key        = {tool.id}
          offerId    = {offerId}
          loggedIn   = {isLoggedIn}
          subscribed = {isSubscribed}
          requested  = {isRequested}
          hasOrd     = {offer.has_agreement_with_ord}
          {...tool}
        />
      ))}
    </div>
  );
}

Tools.propTypes = {
  offerId                : PropTypes.number.isRequired,
  offerToolIds           : PropTypes.arrayOf(PropTypes.number).isRequired,
  offerSubscriptionStatus: PropTypes.number.isRequired,

  t: PropTypes.func.isRequired,

  dispatch: PropTypes.func.isRequired,

  isLoggedIn: PropTypes.bool,
  language: PropTypes.string,
  toolsById : PropTypes.objectOf(PropTypes.object).isRequired,
  isLoadingTools: PropTypes.bool,
  isLoadedTools: PropTypes.bool,
  subscriptions: PropTypes.arrayOf(PropTypes.object),
  isLoadedSubscriptions: PropTypes.bool,
  accessRequested: PropTypes.objectOf(PropTypes.bool),
};

export default compose(
  connect(
    (state, { offerId }) => ({
      isLoggedIn: state.auth.isLoggedIn,

      language: state.language.language,

      toolsById: state.offers.toolsById,
      isLoadingTools: state.offers.isLoadingTools,
      isLoadedTools: state.offers.isLoadedTools,

      offer: state.offers.offersById[offerId] || {},
      subscriptions: state.offers.offerSubscriptionIdsByOfferId[offerId]?.map(id => state.offers.offerSubscriptionsById[id]),
      isLoadedSubscriptions: typeof state.offers.offerSubscriptionIdsByOfferId[offerId] !== 'undefined',

      accessRequested: state.offers.accessRequested,
    })
  ),
  withTranslation(['Offers'], { i18n, wait: false }),
)(Tools);
